var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"box"}},[(_vm.show)?_c('div',{staticClass:"boxShow",on:{"click":function($event){return _vm.changeBox(false)}}},[_c('i',{staticClass:"el-icon-arrow-left"})]):_c('div',{staticClass:"boxHidden",on:{"click":function($event){return _vm.changeBox(true)}}},[_c('i',{staticClass:"el-icon-arrow-right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }